"use strict";

import _classCallCheck from "/home/user/jeronimo3333/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/user/jeronimo3333/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/user/jeronimo3333/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/user/jeronimo3333/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/user/jeronimo3333/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/user/jeronimo3333/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { toUtf8Bytes, toUtf8String } from "@ethersproject/strings";
import { DynamicBytesCoder } from "./bytes";
export var StringCoder = /*#__PURE__*/function (_DynamicBytesCoder) {
  _inherits(StringCoder, _DynamicBytesCoder);
  function StringCoder(localName) {
    _classCallCheck(this, StringCoder);
    return _possibleConstructorReturn(this, _getPrototypeOf(StringCoder).call(this, "string", localName));
  }
  _createClass(StringCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      return _superPropGet(StringCoder, "encode", this, 3)([writer, toUtf8Bytes(value)]);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return toUtf8String(_superPropGet(StringCoder, "decode", this, 3)([reader]));
    }
  }]);
  return StringCoder;
}(DynamicBytesCoder);